import React, { useEffect, useRef } from 'react';
import AuditLogsData from '@components/profile/auditLogs/auditLogsData';
import useInfiniteScroll from '@hooks/useInfiniteScroll';
import useStores from '@stores/useStores';
import { observer } from 'mobx-react';
import { LogType } from '@components/profile/auditLogs';

interface Props {
  targetId: string;
}

const AuditLogs = ({ targetId }: Props) => {
  const { auditLogsStore } = useStores();
  const pageEndRef = useRef(null);

  useEffect(() => {
    auditLogsStore.setTarget(targetId);
    auditLogsStore.getLogs(LogType.ALL);
    /* When fetching all audit logs, target should be undefined */
    return () => auditLogsStore.setTarget(undefined);
  }, []);

  useInfiniteScroll(pageEndRef, auditLogsStore.getMore);

  return (
    <>
      <AuditLogsData logs={auditLogsStore.parsedLogs} loading={auditLogsStore.loading} lessInfo />
      <div ref={pageEndRef} />
    </>
  );
};

export default observer(AuditLogs);
